import { useState, useEffect, useRef } from 'react';
import {
  Cart,
  CartEntry,
  CartEventDataInterface,
  SopElementResponse,
  VariantDimensions,
  getAllEntries,
  CartEventsEnum,
  updateCart,
  getStockStatus,
  getBundleEntriesAndChildPromoitions,
  getVariantName,
  createProductEntryKey,
  PublishEvent,
  getStrikeThroughPrice,
  CartConstantsEnum,
  type CartEntryDetails,
  getActiveCart,
  getErrorFromEntryOrSubCart,
  publishLoaderEvent,
  CartEvents,
  CartEventsVersionsEnum,
  OrderType,
  isPickUpItemUnavailable,
  isDeliveryItemUnavailable,
  isThirdPartyPickUpUnavailable,
  getExceptionProducts,
  isGroupOrder,
  transformedSOPEntries,
  RenewalFlag,
  AccountProcessType,
  cartApi,
  deletePaymentDetails,
  MyShopStorageConstant,
  bottomMsgPresent,
  getPlanName,
  isSellableCheck,
  getUniquePromotions,
  hideVariantSelector,
  updateIsCheckoutDisabled,
  getpkitAndeKitProductId,
  CartRoutePaths,
  includesAny,
  getEKitTermsAndConditionsConfig,
} from '@commerce-cart-webcomponents/sdk';
import { ProductCartEntryComponent } from '@commerce-product-webcomponents/ui-composite';
import { useDispatch } from 'react-redux';

import { StorageService, Logger } from '@nextgen-web-framework/core';
import type { AppDispatch } from '@nextgen-web-framework/core';
import { useTranslation, useSession, useNextgenRouter } from '@nextgen-web-framework/all';
import { AdvanceShareCodeResponse } from '@commerce-webcomponents/sdk';
import { FreeProductCard } from '@commerce-product-webcomponents/ui';
import { AccountProductType } from '@commerce-cart-webcomponents/sdk/services/models/AccountProductType';
import {
  CartNotificationTheme,
  ModalWrapper,
  useCartNotification,
  useExceptionToast,
  useFetchSubscriptionCmsContent,
  useFeatureFlag,
} from '../../common';
import { ItemsUnavailable } from '../cart-total/items-unavailable/ItemsUnavailable';
import { ItemsRemovedModal } from '../items-removed-modal/ItemsRemovedModal';
import { CartMobileHeader } from '../cart-mobile-header/CartMobileHeader';
import { AddSubCartIcon } from '../add-sub-cart-icon/AddSubCartIcon';
import { CartEllipsisMenu } from '../cart-ellipsis-menu/CartEllipsisMenu';
import { GCOList } from '../gco-list/GCOList';
import { CartLineItemErrorMessages } from '../cartLineItem-error-msgs/CartLineItemErrorMessages';
import { AddProductsFromList } from '../lists/components/add-products-from-list/AddProductsFromList';
import { createDataObject } from '../../utils';
import { KitTermsAndConditions } from './kitTermsAndConditions/KitTermsAndConditions';
import { CartLineItemsHeader } from './cartLineItemsHeader/CartLineItemsHeader';
import styles from './CartLineItems.module.scss';
import { TOAST_TIMEOUT, INFINITE_SHIPMENTS, UNLIMITED_MONTH_CYCLE } from './types/enum';
import { CartLineItemsFooter } from './cart-line-items-footer/CartLineItemsFooter';
import { SOPVariantDrawer } from './sop-variant-drawer/SOPVariantDrawer';
import { SopItemErrorMsgs } from './sop-items-error-msgs/SopItemErrorMsgs';

interface CartLineItemsProps {
  data: Cart;
  clickedShowCart: (arg: string) => void;
  displayGCO: boolean;
  isMainUserCart: boolean;
  cartDetailsPage?: boolean;
}

/**
 *
 * @param props
 * @returns
 *
 */
export const CartLineItems = (props: CartLineItemsProps) => {
  const { data, clickedShowCart, displayGCO, isMainUserCart, cartDetailsPage } = props;
  const { createToast, deleteToast } = useCartNotification('cartLineItem');
  const t = useTranslation();
  const subscriptionIds = useRef<string[]>();
  const productsRemovedText = t('cart.cartLineItem.productsRemoved');
  const invalidProductsRemovedText = t('cart.cartLineItem.invalidProductsRemovedText');
  const showRemoveSuccess = t('cart.cartlineItemHeader.removeSuccess');
  const currentlyUnavailableText = t('cart.errorMessages.currentlyUnavailble');
  const cartPromoNotEligibleText = t('cart.errorMessages.cartPromotions');
  const [regDetailsLost, setRegDetailsLost] = useState(false);
  const { hidePromotionBannerFlag, hideBVFlag, showSOPSingleItemFlag, showAuxiliaryToggleFlag } = useFeatureFlag();

  const undoText = t('cart.cartLineItem.undo');
  const { isABO, isAnonymous } = useSession();
  const dispatch = useDispatch<AppDispatch>();

  const [showPromotionLoadings, setShowPromotionLoadings] = useState<{
    [key: string]: boolean;
  }>({});
  const router = useNextgenRouter();
  const loggerInstance = Logger.getInstance();
  const [removeEntryId, setRemoveEntryId] = useState<number[]>([]);
  const triggerToast = useExceptionToast();
  const triggerOnlyEKitToast = useExceptionToast({
    theme: CartNotificationTheme.PURPLE,
    content: t('cart.cartLineItems.eligibleForEKit'),
    subtext: t('cart.cartLineItems.AcceptTAndC'),
    icon: 'bolt',
  });

  const cartId = router.params?.cartId ?? '';

  const mainSubCart = getActiveCart(data, cartId as string);
  const { entries: cartEntries, sopMetaData } = mainSubCart;
  const showTermsAndConditions = getEKitTermsAndConditionsConfig();

  const sopCMSData = useFetchSubscriptionCmsContent(sopMetaData || []);
  const [openDrawerId, setOpenDrawerId] = useState<number | null>(null);
  const [cartEntryData, setCartEntryData] = useState<CartEntryDetails>();

  const shareCode = StorageService.getLocalStorage().retrieve(
    MyShopStorageConstant.SHARECODEATTRIBUTES,
  ) as AdvanceShareCodeResponse;

  const { withSOPEntry, withoutSOPEntry } = getAllEntries(cartEntries as CartEntryDetails[]);

  const [showCompensatedModal, setShowCompensatedModal] = useState<boolean>(false);
  const [invalidFlag, setInvalidFlag] = useState<boolean>(false);

  const addToCartItem = async (cartEntry: CartEntryDetails, toastId: string) => {
    const payload = {
      subCarts: [
        {
          subCartId: mainSubCart.subCartId,
          entries: [cartEntry],
        },
      ],
      version: Number(StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion)),
    };
    const res = await cartApi.addToCart({
      cartId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
      subCartId: mainSubCart?.subCartId,
      payload,
    });
    deleteToast(toastId);
    dispatch(updateCart(res as Cart));
    PublishEvent({
      cartEvent: CartEventsEnum.AddToCart,
      cartEntry,
    });
  };

  const removeEntry = async (entryId: number, entryIdArray: number[] = [], isInvalid = false) => {
    try {
      const cartEntry = (cartEntries as Array<CartEntryDetails>).find((entry: CartEntry) => entry.entryId == entryId);
      publishLoaderEvent(true);
      const res = await cartApi.removeEntryFromCart({
        cartId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
        subCartId: mainSubCart.subCartId,
        entryId: entryIdArray.length !== 0 ? encodeURIComponent(entryIdArray.join(',')) : String(cartEntry?.entryId),
      });
      const deletePaymentRes = await deletePaymentDetails(mainSubCart);
      const updatedRes = (deletePaymentRes ?? res) as Cart;
      setShowCompensatedModal(false);
      publishLoaderEvent(false);
      entryIdArray.length !== 0
        ? createToast(
            {
              theme: isInvalid ? CartNotificationTheme.YELLOW : CartNotificationTheme.SUCCESS,
              rightSeperator: false,
              content: isInvalid ? invalidProductsRemovedText : showRemoveSuccess,
              clickIcon: isInvalid ? undefined : 'times',
              icon: isInvalid ? undefined : 'check-circle',
              timeOut: TOAST_TIMEOUT,
            },
            deleteToast,
          )
        : createToast(
            {
              theme: CartNotificationTheme.PURPLE,
              content: productsRemovedText,
              textlink: undoText,
              timeOut: TOAST_TIMEOUT,
            },
            (id: string) => addToCartItem(cartEntry as CartEntryDetails, id),
          );
      dispatch(updateCart(updatedRes));
      cartEntry &&
        PublishEvent({
          cartEvent: CartEventsEnum.RemoveCartEntry,
          cartEntry,
          cart: updatedRes,
        });
      PublishEvent({
        cartEvent: CartEventsEnum.UpdateMiniCartIcon,
        cart: updatedRes,
      });
    } catch (error) {
      triggerToast();
      publishLoaderEvent(false);
      loggerInstance.error(error);
    }
  };

  const { removedProducts, invalidProducts } = getExceptionProducts(cartEntries as CartEntryDetails[]);

  const newEntries = withoutSOPEntry.filter((item) => !removedProducts.includes(item));

  useEffect(() => {
    if (invalidProducts !== undefined && invalidProducts.length !== 0 && !invalidFlag) {
      setInvalidFlag(true);
      const removedEntriesPayload = invalidProducts
        .map((entry) => entry.entryId)
        .filter((id): id is number => id !== undefined);

      removeEntry(0, removedEntriesPayload, true);
    }
  }, [invalidProducts]);

  useEffect(() => {
    const showLoaderEvent = CartEvents.subscribeEvents({
      topics: [CartEventsEnum.ShowLoader],
      version: CartEventsVersionsEnum['1.0.0'],
      cb: (message: string, { entryId }: CartEventDataInterface) => {
        setShowPromotionLoadings((prev) => ({
          ...prev,
          [entryId as string]: true,
        }));
      },
    });

    const hideLoaderEvent = CartEvents.subscribeEvents({
      topics: [CartEventsEnum.HideLoader],
      version: CartEventsVersionsEnum['1.0.0'],
      cb: (message: string, { entryId }: CartEventDataInterface) => {
        setShowPromotionLoadings((prev) => ({
          ...prev,
          [entryId as string]: false,
        }));
      },
    });

    subscriptionIds.current = [...hideLoaderEvent, ...showLoaderEvent];

    return () => {
      CartEvents.unsubscribe(subscriptionIds.current);
    };
  }, []);

  const regEntry = newEntries?.find((entry) => includesAny(entry, [AccountProductType.Ekit, AccountProductType.Pkit]));
  const hideSelector = hideVariantSelector?.(data, regEntry as CartEntryDetails, Boolean(shareCode), newEntries);
  const { pkitProductId, ekitProductId } = getpkitAndeKitProductId();

  useEffect(() => {
    if (hideSelector && data.accountProcess?.type === AccountProcessType.Registration) {
      if (regEntry?.product?.id === pkitProductId) {
        const cartId = StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId);
        cartApi
          .updateCart(cartId, cartId, {
            accountProcess: {
              ...data.accountProcess,
              variantProduct: ekitProductId,
            },
            version: +StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion),
          })
          .then((res) => {
            dispatch(updateIsCheckoutDisabled(true));
            dispatch(updateCart(res as Cart));
            triggerOnlyEKitToast();
          });
        return;
      }
      triggerOnlyEKitToast();
    }
  }, [hideSelector]);

  useEffect(() => {
    const isSelfLedReg =
      regEntry && data?.accountProcess?.type === AccountProcessType.Registration && Boolean(!shareCode);

    if (isSelfLedReg) {
      router.events?.setIsBackBlocked(true);

      router.events?.on('browserBackWarn', () => setRegDetailsLost(true));
      window.history.pushState(null, document.title, window.location.href);
    }
    return () => {
      if (isSelfLedReg) {
        router.events?.setIsBackBlocked(false);
        router.events?.off('browserBackWarn', () => setRegDetailsLost(true));
        window.history.replaceState(null, document.title, window.location.href);
      }
    };
  }, [regEntry]);

  const renderAuxiliaryProducts = (id: string) => {
    const AuxiliaryProducts: CartEntryDetails[] = [];

    //if qualifyingItemIds length is more than 1 then it will be shown at the top
    const receivedEntries = newEntries.filter(
      (entry) =>
        entry?.product?.isAuxiliary && entry?.qualifyingItemIds?.length === 1 && entry?.qualifyingItemIds?.[0] === id,
    );
    receivedEntries && AuxiliaryProducts?.push(...receivedEntries);

    return (
      <>
        {Boolean(AuxiliaryProducts?.length) &&
          AuxiliaryProducts?.map((entry) => {
            const { product, totalPrice } = entry;
            return (
              <div
                key={entry.entryId}
                className={styles['commerce-cart-line-item-product']}
                data-testid="product-card-test-id"
              >
                <FreeProductCard
                  brandName={product?.brand ?? ''}
                  productName={product?.name ?? ''}
                  link={product?.cartIconPublicUrl ?? ''}
                  alt={product?.cartIconAltText ?? ''}
                  productId={''}
                  productPrice={totalPrice?.value as number}
                  currency={totalPrice?.currency as string}
                  productSize={''}
                  derivedAvailabilityStatus={getStockStatus(entry)}
                  showSubText={false}
                  productQuantity={entry?.quantity}
                  isSopBenefit={false}
                  showLinkForProductCard={!isSellableCheck(product)}
                  showDispositionHandler={false}
                  showPromotionTag={entry?.enablePromotionTag}
                  firstAvailableFutureDate={
                    product?.firstAvailableFutureDate && String(product.firstAvailableFutureDate)
                  }
                />
              </div>
            );
          })}
      </>
    );
  };

  const onSOPRemoveClickHandler = (receivedSOPId?: string, receivedEntryIds?: number[]) => {
    let updatedCount = 0;
    const hasCompensatedOrder = sopMetaData?.reduce((count, data) => {
      if (data.entryIds !== undefined && data.sopId === receivedSOPId) {
        setRemoveEntryId((prev) => [...prev, ...(data.entryIds as number[])]);
        updatedCount = count + 1;
      }
      return updatedCount;
    }, 0);

    if (hasCompensatedOrder && hasCompensatedOrder > 1) {
      setShowCompensatedModal(true);
    } else {
      removeEntry(0, receivedEntryIds);
    }
  };

  const showRemoveIconRenewal = (entry: CartEntryDetails) =>
    !includesAny(entry, [AccountProductType.Ekit, AccountProductType.Pkit]) ||
    (data.accountProcess?.type === AccountProcessType.Renewal &&
      (data.amwayUser.renewalFlag === RenewalFlag.CanRenew || isABO()));

  const onEntryRemove = async (entry: CartEntryDetails) => {
    const version = +StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion);
    if (includesAny(entry, [AccountProductType.Ekit, AccountProductType.Pkit])) {
      const deleteAccountProcessPayload = {
        version,
        removeAccountProcess: true,
      };
      const res = await cartApi.updateCart(data.id, mainSubCart.subCartId as string, deleteAccountProcessPayload);
      dispatch(updateCart(res as Cart));
      PublishEvent({
        cartEvent: CartEventsEnum.UpdateMiniCartIcon,
        cart: res as Cart,
      });
      return;
    }
    removeEntry(entry.entryId as number);
  };

  return (
    <div className={styles['commerce-cart-line-items-page']}>
      {showCompensatedModal && (
        <ItemsUnavailable
          notAvailableEntries={[]}
          isCompensatedModal
          onPrimaryBtnClick={() => removeEntry(0, removeEntryId)}
          onSecondaryBtnClick={() => setShowCompensatedModal(false)}
        />
      )}
      {Boolean(removedProducts.length) && (
        <ItemsRemovedModal
          orderType={data.orderType}
          currentActiveCart={mainSubCart}
          removedEntries={removedProducts}
        />
      )}
      <div className={styles['commerce-cart-line-item-header']}>
        <CartMobileHeader isGCOList={displayGCO} />
        {isGroupOrder(data.orderType) && !cartDetailsPage ? <AddSubCartIcon /> : null}
        {!displayGCO && data && (
          <div
            className={
              isMainUserCart
                ? styles['commerce-cart-line-item-header-ellipis-menu-show']
                : 'commerce-cart-line-item-header-ellipis-menu-hidden'
            }
          >
            <CartEllipsisMenu
              currentCartId={mainSubCart?.subCartId}
              isNonGCO={isMainUserCart && !isGroupOrder(data.orderType)}
              cartEntriesDetails={cartEntries}
            />
          </div>
        )}
      </div>
      <CartLineItemsHeader
        data={data}
        cartDetailsPage={cartDetailsPage}
        onEntryRemove={(entry) => onEntryRemove(entry)}
        displayGCO={displayGCO}
      />
      {/* GCOList Start */}
      {displayGCO && Object.keys(data).length > 0 && (
        <GCOList subCarts={(data.subCarts || []) as Cart[]} clickedShowCart={clickedShowCart} />
      )}
      {/* GCOList End */}
      {/* Cart line items */}

      {!displayGCO && cartEntries && cartEntries?.length != 0 && (
        <div className={styles['commerce-cart-line-item']}>
          {sopMetaData &&
            sopMetaData?.length !== 0 &&
            sopMetaData?.map((sopElement: SopElementResponse) => {
              const {
                totalPrice,
                elementSequence,
                totalShipments,
                images,
                promotionResults,
                totalPriceWithoutDiscount,
                sopCode,
                planCode,
              } = sopElement;
              const dataObjectFromEntry = createDataObject(
                undefined,
                totalPrice,
                promotionResults,
                isABO(),
                hideBVFlag,
              );

              const handleDropdown = (cartEntry: CartEntryDetails) => {
                setOpenDrawerId((prevId) => (prevId === cartEntry.entryId ? null : cartEntry.entryId ?? null));
                setCartEntryData(cartEntry);
              };
              const receivedSOPData = transformedSOPEntries(
                withSOPEntry,
                sopElement,
                isABO(),
                router?.params?.locale as string,
                currentlyUnavailableText,
                cartPromoNotEligibleText,
                handleDropdown,
              );
              const isSingleSOPItem = showSOPSingleItemFlag && receivedSOPData.sopProducts.length === 1;
              const receivedPlanName = getPlanName(planCode, sopCMSData);

              return (
                <>
                  <div key={sopElement.sopElementId} className={styles['commerce-cart-line-item-product']}>
                    {openDrawerId && sopElement.entryIds?.includes(openDrawerId) && (
                      <SOPVariantDrawer
                        planCode={planCode}
                        entryData={cartEntryData as CartEntryDetails}
                        onCloseClick={() => setOpenDrawerId(null)}
                      />
                    )}
                    <ProductCartEntryComponent
                      onRemoveProduct={() => onSOPRemoveClickHandler(sopElement.sopId, sopElement.entryIds)}
                      subscriptionQtyStepperComp={
                        isSingleSOPItem ? (
                          <div className={styles['commerce-cart-line-item-product-qtyLabel']}>
                            x {receivedSOPData.sopProducts[0].quantity}
                          </div>
                        ) : (
                          <></>
                        )
                      }
                      showPropertiesCollection={{
                        showSubscriptionCard: !isSingleSOPItem,
                        showHeartIcon: isSingleSOPItem,
                        showQtyStepper: isSingleSOPItem,
                        showSubscriptionTag: true,
                        showRemoveIcon: true,
                        showCloseCta: false,
                        showCompensatedSOPTag: sopElement.isCompensated,
                      }}
                      data={{
                        ...dataObjectFromEntry,
                        productName: isSingleSOPItem
                          ? receivedSOPData.sopProducts[0].productName
                          : (receivedPlanName as string),
                        link: isSingleSOPItem ? receivedSOPData.sopProducts[0].link : (images?.[0]?.imageUrl as string),
                        alt: isSingleSOPItem ? receivedSOPData.sopProducts[0].alt : (images?.[0]?.altText as string),
                        firedPromotions: hidePromotionBannerFlag ? [] : promotionResults?.firedPromotions,
                        minOrder: elementSequence,
                        maxOrder: totalShipments === INFINITE_SHIPMENTS ? UNLIMITED_MONTH_CYCLE : totalShipments,
                        subscriptionId: sopCode,
                        strikethroughPrice: totalPriceWithoutDiscount?.value,
                        subscriptionProducts: receivedSOPData.sopProducts,
                        items: [],
                        ...(isSingleSOPItem && {
                          derivedAvailabilityStatus: receivedSOPData?.sopProducts[0]?.derivedAvailablityStatus,
                          firstAvailableFutureDate: receivedSOPData?.sopProducts[0]?.firstAvailableFutureDate,
                          showPrefix: false,
                          productType: receivedSOPData?.sopProducts[0]?.productType,
                          productQuantity: receivedSOPData?.sopProducts[0]?.quantity,
                          productId: receivedSOPData?.sopProducts[0]?.productId,
                          bundle: receivedSOPData?.sopProducts[0]?.bundle,
                          variantName: receivedSOPData?.sopProducts[0]?.variantName,
                          handleDropdown: receivedSOPData?.sopProducts[0]?.handleDropdown,
                        }),
                      }}
                      cartBaseurl={''}
                    />
                    <SopItemErrorMsgs
                      sopElement={sopElement}
                      onSOPRemoveClickHandler={onSOPRemoveClickHandler}
                      isSopOOS={receivedSOPData.isOOS}
                      classname={styles['cart-exceptionAlert']}
                    />
                  </div>
                  {showAuxiliaryToggleFlag && renderAuxiliaryProducts(sopElement.sopElementId)}
                </>
              );
            })}
          {newEntries?.map((entry: CartEntryDetails, index: number) => {
            if (
              includesAny(entry, [AccountProductType.Fee, AccountProductType.LateFee]) &&
              !includesAny(entry, [AccountProductType.Ekit, AccountProductType.Pkit])
            ) {
              return false;
            }
            const { product, promotionResults, totalPrice, rationingResult } = entry;
            const dataObjectFromEntry = createDataObject(product, totalPrice, promotionResults, isABO(), hideBVFlag);
            const { bundleEntries, childPromotions } = getBundleEntriesAndChildPromoitions(
              entry,
              currentlyUnavailableText,
              cartPromoNotEligibleText,
            );
            const productStockstatus = getStockStatus(entry);

            const isBottomMsgPresent = bottomMsgPresent(promotionResults, productStockstatus);
            const hasShippingError =
              isPickUpItemUnavailable(true, {}, entry) ||
              isDeliveryItemUnavailable(true, {}, entry) ||
              isThirdPartyPickUpUnavailable(true, {}, entry);

            const isAccountKitProduct = includesAny(entry, [AccountProductType.Ekit, AccountProductType.Pkit]);

            return (
              <>
                {!entry.isFreeItem && !entry.partnerPromotionId && (
                  <>
                    <div
                      key={entry.entryId}
                      className={`${index == cartEntries.length - 1 && styles['commerce-cart-shipping-seperator-end']}
                ${styles['commerce-cart-line-item-product']}`}
                      data-testid="product-card-test-id"
                    >
                      {regDetailsLost && (
                        <ModalWrapper
                          headLineText={t('cart.cartLineitems.regDetailsLostHeading')}
                          description={t('cart.cartLineitems.regDetailsLostDesc')}
                          primaryButtonLabel={t('cart.cartLineitems.underStandAndGoBack')}
                          secondaryButtonLabel={t('cart.groupOrder.button.cancel')}
                          onPrimarySuccess={() => {
                            router.push(CartRoutePaths.SELF_LED_REGISTRAION);
                          }}
                          onSecondarySuccess={() => setRegDetailsLost(false)}
                        />
                      )}
                      <ProductCartEntryComponent
                        key={createProductEntryKey(entry, mainSubCart.amwayUser)}
                        onRemoveProduct={() => onEntryRemove(entry)}
                        showCartInventoryUpdate={!!getErrorFromEntryOrSubCart(entry)}
                        showPropertiesCollection={{
                          showHeartIcon: !isAnonymous() && !isAccountKitProduct,
                          showRemoveIcon: showRemoveIconRenewal(entry),
                          showCloseCta: false,
                          showQtyStepper: !isAccountKitProduct,
                          showPVBV: !isAccountKitProduct || totalPrice?.value !== 0,
                          showStockStatus: !isAccountKitProduct,
                          showItemId: !isAccountKitProduct,
                          showInstallment:
                            product.flags?.isInstallmentPlanEligible && data.orderType === OrderType.Regular,
                          showPriceLabel: !isAccountKitProduct,
                          showPromotionTag: entry?.enablePromotionTag,
                          showRenewalCard: isAccountKitProduct,
                          showApointTag: entry?.isAmpointRedeem,
                        }}
                        showPromotionLoader={showPromotionLoadings[entry.entryId as number]}
                        data={{
                          ...dataObjectFromEntry,
                          productName: product.name ?? '',
                          items: [],
                          link: product.cartIconPublicUrl ?? '',
                          alt: product.cartIconAltText as string,
                          disabled: rationingResult?.[0]?.availableQuantity === 0,
                          variantName: hideVariantSelector?.(data, entry, Boolean(shareCode), newEntries)
                            ? ''
                            : getVariantName(product.variantDimensions as VariantDimensions[]),
                          bundle: bundleEntries,
                          strikethroughPrice: getStrikeThroughPrice(entry),
                          firedPromotions: hidePromotionBannerFlag
                            ? []
                            : getUniquePromotions(
                                [...(promotionResults?.firedPromotions ?? []), ...childPromotions],
                                showAuxiliaryToggleFlag,
                              ),

                          derivedAvailabilityStatus:
                            (!hasShippingError &&
                              !entry.product.flags?.restrictFromCheckout &&
                              getStockStatus(entry)) ||
                            '',
                          firstAvailableFutureDate:
                            product.firstAvailableFutureDate && String(product.firstAvailableFutureDate),
                          showPrefix: false,
                          showSubText: true,
                          entryId: entry?.entryId,
                          productType: product.type,
                          restrictFromPdpDisplay: isAccountKitProduct || isSellableCheck(product),
                        }}
                        cartBaseurl={''}
                      />

                      <CartLineItemErrorMessages
                        data={data}
                        entry={entry}
                        removeRationingItemCB={removeEntry}
                        bottomMsgPresent={isBottomMsgPresent}
                        hasShippingError={hasShippingError}
                      />
                      {includesAny(entry, [AccountProductType.Ekit]) && showTermsAndConditions && (
                        <KitTermsAndConditions />
                      )}
                    </div>
                    {showAuxiliaryToggleFlag && renderAuxiliaryProducts(String(entry?.entryId))}
                  </>
                )}
              </>
            );
          })}
          <CartLineItemsFooter cartDetailsPage={cartDetailsPage} cartData={data} />
          <AddProductsFromList />
        </div>
      )}
    </div>
  );
};

export type { CartLineItemsProps };
